export default class PressPriceModel {
  constructor () {
    this.품번 = null
    this.cvt = null
    this.자사가로 = null
    this.자사세로 = null
    this.자사두께 = null
    this.자사중량 = null
    this.자사net = null
    this.자사스크랩중량 = null
  }
}
